import React, { type PropsWithChildren, useRef } from 'react'
import { useOnClickOutside } from 'usehooks-ts'

const ClickOutSide: React.FC<
  PropsWithChildren<
    { onClickOutSide: () => void } & React.HTMLAttributes<HTMLDivElement>
  >
> = ({ children, onClickOutSide, ...rest }) => {
  const componentRef = useRef<HTMLDivElement>(null)

  useOnClickOutside(componentRef, onClickOutSide)

  return (
    <div ref={componentRef} {...rest}>
      {children}
    </div>
  )
}

export default ClickOutSide
